import { PipesDisabledConfigBandDisk } from "../types/Contract.config.types"


export const PipesDisabledConfig: PipesDisabledConfigBandDisk = {
    compute:{
        serverCatalogProp:'bandwidths',
        available:'bandwidthAvailable',
        currentProfile:'bandwidth'
    },
    band:{
        serverCatalogProp:'bandwidths',
        available:'bandwidthAvailable',
        currentProfile:'bandwidth'
    },
    disk:{
        serverCatalogProp:'disks',
        available:'diskAvailable',
        currentProfile:'disk'
    }
}

export const PipesDisabledConfigArray = [PipesDisabledConfig.band, PipesDisabledConfig.disk]